import { CalendarCheckIcon, CardsIcon, ExpenseReportIcon, ReceiptIcon } from '@emburse/embark-icons';
import { CREATE_EXPENSE_REPORT_OPTIONS } from './constants';
export const CREATE_EXPENSE_REPORT_OPTIONS_DEFAULT = [
    {
        id: '1',
        label: 'Add all items to a report',
        value: CREATE_EXPENSE_REPORT_OPTIONS.ALL_ITEMS,
        iconUrl: ReceiptIcon
    },
    {
        id: '2',
        label: 'Add credit card transactions to a report',
        value: CREATE_EXPENSE_REPORT_OPTIONS.CREDIT_CARD_TRANSACTIONS,
        iconUrl: CardsIcon
    },
    {
        id: '3',
        label: 'Select a date range to add some items to a new report',
        value: CREATE_EXPENSE_REPORT_OPTIONS.DATE_RANGE,
        iconUrl: CalendarCheckIcon
    },
    {
        id: '4',
        label: 'Start a new blank expense report',
        value: CREATE_EXPENSE_REPORT_OPTIONS.BLANK,
        iconUrl: ExpenseReportIcon
    }
];
export const CREATE_EXPENSE_REPORT_OPTIONS_FROM_WALLET = [
    {
        id: '5',
        label: 'Add items to a new report',
        value: CREATE_EXPENSE_REPORT_OPTIONS.OPTION_5,
        iconUrl: ExpenseReportIcon
    },
    {
        id: '6',
        label: 'Add items to an existing report Experts',
        value: CREATE_EXPENSE_REPORT_OPTIONS.OPTION_6,
        iconUrl: ExpenseReportIcon
    }
];
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
